import axios from "axios";

export async function getClientDataGivenClientCode({ clientCode }) {

  try {
    const response = await axios.get(
      `https://app.deb00.it/api/get-client-by-code/${clientCode}`
    );
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}
